export interface RouteDefinition {
  path: string;      // e.g. '/register/:workshopSlug'
  component: string; // e.g. 'registration-form'
}

export interface RouteMatch {
  component: string;
  params: Record<string, string>;
}

class RouterController {
  private routes: RouteDefinition[] = [];

  configure(routes: RouteDefinition[]): void {
    this.routes = routes;
  }

  match(pathname: string): RouteMatch | null {
    for (const route of this.routes) {
      const params = this.extractParams(route.path, pathname);
      if (params !== null) {
        return { component: route.component, params };
      }
    }
    return null;
  }

  private extractParams(pattern: string, pathname: string): Record<string, string> | null {
    const patternParts = pattern.split('/');
    const pathParts = pathname.split('/');
    if (patternParts.length !== pathParts.length) return null;

    const params: Record<string, string> = {};
    for (let i = 0; i < patternParts.length; i++) {
      if (patternParts[i].startsWith(':')) {
        params[patternParts[i].slice(1)] = decodeURIComponent(pathParts[i]);
      } else if (patternParts[i] !== pathParts[i]) {
        return null;
      }
    }
    return params;
  }

  async setRoot(url: string) {
    window.history.pushState(null, '', url);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }

  async forwardTo(url: string) {
    window.history.pushState(null, '', url);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }

  async backTo(url: string) {
    window.history.pushState(null, '', url);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }

  async back() {
    window.history.back();
  }

  async checkError(error: any) {
    try {
      let errorString = error as string;
      if (errorString.includes('401') || errorString.includes('403')) {
        document.dispatchEvent(new CustomEvent('userAuthChanged', {
          bubbles: true,
          detail: { user: null }
        }));
        RouterService.setRoot('/');
      }
    }
    catch (_err) {}
  }
}

export const RouterService = new RouterController();
